export default __webpack_public_path__ + "locales/pt-BR/FillPDFDialog.json?hash=cd9406ee72b56916965e5e800427f34c";